import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownPostBookingController,
  type UnifiedPriceBreakdownPostBookingControllerProps
} from "./useUnifiedPriceBreakdown.PostBooking.controller";

export type UnifiedPriceBreakdownPostBookingProps = UnifiedPriceBreakdownPostBookingControllerProps;

export function UnifiedPriceBreakdownPostBooking(props: UnifiedPriceBreakdownPostBookingProps) {
  const { unifiedPriceBreakdown, isHungaryDepartingRyanAir, disclaimers, addedItems, expandedByDefault } =
    useUnifiedPriceBreakdownPostBookingController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        addedItems={addedItems}
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <SIRF />
    </Stack>
  );
}
